/**
 * SDK namespace, or null until initAzureDevopsSDK() has finished initializing it.
 * Read-only for importers.
 * @type {typeof import('azure-devops-extension-sdk') | null}
 */
export let AZURE_DEVOPS_SDK = null
/** Guards against a second init call. Module-private. */
let installCalled = false

/**
 * Loads the SDK and runs init(). Must be called exactly once.
 * Throws on any repeat or concurrent call.
 * @returns {Promise<void>}
 * @throws {Error} if called more than once.
 */
export const initAzureDevopsSDK = async () => {
  if (installCalled) {
    throw new Error('azure-sdk: initAzureDevopsSDK() must be called exactly once')
  }
  installCalled = true

  const sdk = await import('azure-devops-extension-sdk')
  await sdk.init()
  AZURE_DEVOPS_SDK = sdk
}
